export const enum RoutePaths {
    OfficeHome = '',
    OfficeHomeFallback = 'home',
    AppGallery = 'apps',
    Search = 'search',
    SearchPersonScoped = 'search/content',
    SearchTopicScoped = 'search/topic',
    SearchMeetingScoped = 'search/meeting',
    SearchPersonScopedOverview = 'search/overview',
    Templates = 'template/:app',
    OneDriveStart = 'launch/onedrive',
    SharePointStart = 'launch/sharepoint',
    WacStart = 'launch/:app',
    MyForms = 'myforms',
    GroupForms = 'groupforms',
    ContentHost = 'launch/:app/content',
    Pwa = 'pwa',
    BizChat = 'bizchat', // Route for Copilot Native App
    Create = 'create',
    CatchUp = 'catchup',
    Collect = 'collect',
    Pages = 'pages',
    Prepare = 'prepare',
    People = 'people',
    News = 'news',
    Browse = 'browse',
    AiHubSample = 'aiHubSample',
    Assist = 'assist',
    Actions = 'actions',
    Automate = 'automate',
    AppHosted = 'apphosted/:appName',
    FluidContentHost = 'launch/fluid/content',
    M365Apps = 'm365apps',
    FluidFailurePath = 'launch/fluid/unsupported',
    Embed = 'embed',
    ConsumerAllSearch = 'search/main',
    ConsumerFileSearch = 'search/docs',
    ConsumerTemplateSearch = 'search/templates',
    DraftContent = 'mycontent/drafts/content',
    MyContent = 'mycontent',
    ModernStart = 'modernlaunch/:app',
    Park = 'park',
    CheckIn = 'checkin',
    AppsLogin = 'apps-login',
    Copilot = 'copilot',
    Chat = 'chat', // Route for Copilot MOS App hosted at root
    Workplace = 'workplace',
    MobileChat = 'mobilechat'
}

export const MosAppsHostedAtRoot = ['chat', 'onedrive', 'testapp'];

// Friendly app Id should be lower case
export const AppNameToId = {
    chat: 'd870f6cd-4aa5-4d42-9626-ab690c041429',
    testapp: '07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff',
    onedrive: '377c982d-9686-450e-9a7c-22aeaf1bc162'
};
